import { memo } from 'react';

import type { ApiNotification } from '@izimi/api';

import { NotificationSharedItemAction } from './NotificationSharedItemAction';

const SHARING_ROUTE = '/documents/from-your-notary';

interface Props {
  notification: ApiNotification;
}

export const CommunicationReceivedActions = memo(({ notification }: Props) => (
  <NotificationSharedItemAction notification={notification} targetPath={SHARING_ROUTE} />
));
